export interface UserProfile {
    fullName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string | null;
    phoneNumberConfirmed: boolean;
    tokenAuthEnabled: boolean;
    userId: string;
    userName: string;
    job: UserProfileJob;
    domain: string;
    organizationId: string;
    kno2OrganizationId: number;
    organizationName: string;
    isAdmin: boolean;
    isNetworkAdmin: boolean;
    isIdProofed: boolean;
    idProofProcessStatus: UserIdProofProcessStatus;
    idProofedAttemptDate: string | null;
    idProofedFileName: string | null;
    isAcceptedEULA: boolean;
    orgIsIdProofed: boolean;
    orgIsActivated: boolean;
    orgIsCancelled: boolean;
    orgIsInGracePeriod: boolean;
    orgIsAcceptedEULA: boolean;
    orgIsFreePlan: boolean;
    requiresManualIdProof: boolean;
    administerOfNetworkObjectId: string | null;
    roles: string[];
    sessionTimeoutMinutes: number;
    accessToken: string | null;
    organizations: UserProfileOrganization[];
    host: string;
    fastSpringDomain: string;
    subscriptionReference: string | null;
    partner?: {
        name: string;
        logoUrl: string;
        backgroundColor: string;
    };
    intercomAppId: string;
    intercomUserJwt?: string;
    resellerId: string | null;
    resellerType: "Affiliate" | "Licensing";
    resellerName: string | null;
    resellerBypassTos: boolean;
    finalLoginDate: string | null;
    ipAddress: string;
    brandId: string;
    signaturesProfileSettings: SignaturesProfileSettings;
    externalServiceAccountSettings: ExternalServiceAccountSettings;
    userSettings: UserSettings;
    organizationSettings: OrganizationSettings;
    authStrategy: string;
    authConnection: string | null;
    clientId: string;
    clientIpAddresses: string[];
}

export interface UserProfileJob {
    id: number;
    name: string;
    roleCode: string;
}

export interface UserProfileOrganization {
    role: string;
    id: string;
    subDomain: string;
    name: string;
    url: string;
    isActivated: boolean;
    isAccessible: boolean;
    authRequirements?: OrganizationAuthRequirements;
}

export interface OrganizationAuthRequirements {
    options: OrganizationAuthOption[];
    passwordScope: "Everyone" | "NonUserRoles" | null;
    silent: boolean;
}

export interface OrganizationAuthOption {
    kind: "saml" | "pcc" | "password";
    connectionName: string | null;
    providerType: string | null;
    label: string | null;
}

export interface SignaturesProfileSettings {
    isGetSignaturesEnabled: boolean;
    isSMSNotificationsEnabled: boolean;
    toAddressPrefix: string | null;
    documentType: string | null;
    templateSource: string | null;
}

export interface ExternalServiceAccountSettings {
    hasManagingExternalServiceAccount: boolean;
    hasWebhookAccess: boolean;
    externalServiceAccountName: string | null;
}

export interface UserSettings {
    allowLegacyLogin: boolean;
    allowLegacyLoginCompatibilityMode: boolean;
}

export interface OrganizationSettings {
    allowLegacyLoginCompatibilityMode: boolean;
}

export enum UserIdProofProcessStatus {
    NotIdProofed = "Not_Id_Proofed",
    ManuallyIdProofed = "Manually_Id_Proofed",
    AwaitingManualProofing = "Awaiting_Manual_Proofing",
    AwaitingProofUpload = "Awaiting_Proof_Upload",
    ProofedManually = "Proofed_Manually",
    ProofedByEquifax = "Proofed_By_Equifax",
    ProofedByClear = "Proofed_By_Clear",
    AwaitingUserClearDataConfirmation = "Awaiting_User_Clear_Data_Confirmation",
    Started = "Started"
}
